<template>
  <div v-if="isOpen" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h2 class="modal-title">{{ isEditMode ? 'Edit Category' : 'Add Category' }}</h2>
        <button class="close-button" @click="closeModal">&times;</button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Name -->
        <div class="form-group">
          <label class="form-label">Name <span class="required">*</span></label>
          <input
            v-model="formData.name"
            type="text"
            class="form-control"
            placeholder="e.g. Cloud Services"
          />
        </div>

        <!-- Description -->
        <div class="form-group">
          <label class="form-label">Description</label>
          <textarea
            v-model="formData.description"
            class="form-control description-input"
            placeholder="Optional description..."
          ></textarea>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button class="btn-cancel" @click="closeModal">Cancel</button>
        <button class="btn-primary" @click="handleSubmit" :disabled="!formData.name.trim()">
          {{ isEditMode ? 'Update Category' : 'Create Category' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddCategoryModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    category: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formData: {
        name: '',
        description: ''
      }
    }
  },
  computed: {
    isEditMode() {
      return !!this.category
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        if (this.category) {
          this.formData.name = this.category.name || ''
          this.formData.description = this.category.description || ''
        } else {
          this.resetForm()
        }
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
      this.resetForm()
    },

    handleSubmit() {
      if (!this.formData.name.trim()) return

      const data = {
        name: this.formData.name.trim(),
        description: this.formData.description.trim() || null
      }

      if (this.isEditMode) {
        this.$emit('update', { id: this.category.id, payload: data })
      } else {
        this.$emit('create', data)
      }
    },

    resetForm() {
      this.formData = {
        name: '',
        description: ''
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.15);
  max-width: 460px;
  width: 90%;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 16px;
}

.modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

.close-button {
  background: none;
  border: none;
  font-size: 28px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  color: #1f2937;
}

.modal-body {
  padding: 8px 24px 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.required {
  color: #ef4444;
}

.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #1f2937;
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-control::placeholder {
  color: #9ca3af;
}

.description-input {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px 24px;
}

.btn-cancel {
  background: white;
  color: #1f2937;
  border: 1px solid #d1d5db;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-cancel:hover {
  background: #f3f4f6;
}

.btn-primary {
  background: #2563eb;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-primary:hover {
  background: #1d4ed8;
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
